// extracted by mini-css-extract-plugin
export default {"header":"Au","fullPage":"Bu","closed":"Cu","minimize":"Eu","redcircle":"Fu","container":"Gu","text":"Hu","centered":"Iu","escapex":"Ju"};
    if(module.hot) {
      // 1714654884061
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  